import React from 'react';
import Button from '../../../../../utils/components/Button/Button';
import style from './AdminRoom.module.css'
const AdminDeleteRoom = ({deleteRoom}) => {
  return (
    <div className={style.content_right_container}>
        <div>Esta seguro de borrar la sala?</div>
        <div>
            <Button
            onClick={()=>deleteRoom()}
            text='Si'
            />
        </div>

  </div>);
};

export default AdminDeleteRoom;
